import axios from "axios";
import cookie from "js-cookie";
import { redirect } from "react-router";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getBxiApiKey } from "../config/apiKey";

// Admin API base — env-driven (REACT_APP_API_URL, selected per environment by the
// start:dev/start:prod/start:local scripts). Falls back to the development API.
const BASE_URL =
  (process.env.REACT_APP_API_URL || "https://apiv1production.bxiworld.com").replace(/\/+$/, "") +
  "/api/v1/admin/";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    bxiapikey: getBxiApiKey(),
  },
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    const message = err?.response?.data?.message ?? err?.message ?? "Request failed";
    const status = err?.response?.status;
    if (process.env.NODE_ENV === "development") {
      console.warn("[Admin API error]", status, message, err?.config?.url);
    }
    return Promise.reject(err);
  }
);

export const setToken = (token) => {
  cookie.set("BearerToken", token);
};

export const getToken = () => {
  return cookie.get("BearerToken");
};

export const removeToken = () => {
  cookie.remove("BearerToken");
};

export const checkAuthToken = () => {
  const token = getToken();
  if (!token) {
    return redirect("/login");
  }
  return true;
};

axiosInstance.interceptors.request.use((config) => {
  const token = cookie.get("BearerToken");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export const makeApiCall = async (endpoint, method = "Get", data = null) => {
  try {
    const response = await axiosInstance({ url: endpoint, method, data });
    return response;
  } catch (error) {
    throw error;
  }
};

// Hendle errors

export const handleError = (errorMessage) => {
  toast.error(errorMessage, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: 5000,
  });
};

/** Calls login API and returns response; does not set token (caller must setToken after validating adminType). */
export const loginAdminUserRaw = async (userName, password, adminType) => {
  const endpoint = `auth/login`;
  const postData = { email: userName, password };
  if (adminType === "bxi" || adminType === "brand_world") {
    postData.adminType = adminType;
  }
  return makeApiCall(endpoint, "Post", postData);
};

export const loginAdminUser = async (userName, password) => {
  try {
    const resData = await loginAdminUserRaw(userName, password);
    if (resData?.data?.token) {
      setToken(resData.data.token);
    }
    return resData;
  } catch (error) {
    throw error;
  }
};

export const getTotalSignUpsChartData = async (startDate, endDate) => {
  try {
    const endpoint = `analytics/get-signups?startDate=${startDate}&endDate=${endDate}`;
    const data = await makeApiCall(endpoint);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getTotalTransactionChartData = async (startDate, endDate) => {
  try {
    const endpoint = `analytics/total-transaction?startDate=${startDate}&endDate=${endDate}`;
    const data = await makeApiCall(endpoint);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getMembershipChartData = async (startDate, endDate) => {
  try {
    const endpoint = `analytics/get-membership?startDate=${startDate}&endDate=${endDate}`;
    const data = await makeApiCall(endpoint);
    return data;
  } catch (error) {
    throw error;
  }
};
